export default __webpack_public_path__ + "static/media/img1.b91d16c5.jpg";